import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconBtn from './IconBtn';
import { useState } from 'react';
import Collapse from '@mui/material/Collapse';
import ProfileImage from "./ProfileImage";

export default function TableCom(props) {

    const { data, headers, collapse, collapseStyle, style, actions = [] } = props;

    const [collapseIdx, s_collapseIdx] = useState(-1);

    const CollapseComponent = props.collapseComponent;


    return (
        <TableContainer component={Paper} style={{...style}}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {
                            collapse && <TableCell key="-1" />
                        }
                        {
                            headers.map((header, idx) => <TableCell key={idx}>{header.label}</TableCell>)
                        }
                        {
                            actions.length > 0 && <TableCell key={999999} />
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data && data.map && data.map((row, idx) => (
                        <React.Fragment key={idx + "_f"}>
                            <TableRow
                                key={idx + "_row"}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                {
                                    collapse && <TableCell idx={idx + "_collapse"}>
                                        <IconBtn
                                            disabled={!row.collapseData || row.collapseData.length === 0}
                                            onClick={() => s_collapseIdx(collapseIdx === idx ? -1 : idx)}
                                            customtheme="normal">{idx === collapseIdx ? 'arrowUp' : 'arrowDown'}</IconBtn>
                                    </TableCell>
                                }
                                {
                                    headers.map((header, headerIdx) => {
                                        if(header.type === 'img'){
                                            return (
                                                <TableCell key={headerIdx + "_header"} align="left">{<img
                                                    src={row[header.field]}
                                                    alt='row picture'
                                                    className={`table-image table-image_${headerIdx}`}
                                                />}
                                                </TableCell>
                                            )
                                        }
                                        if(header.type === 'profileImage'){
                                            return (
                                                <TableCell key={headerIdx + "_header"} align="left">
                                                    <ProfileImage
                                                        imageUrl={row[header.field]}
                                                        name={row.name}
                                                    />
                                                </TableCell>
                                            )
                                        }
                                        return(
                                            <TableCell key={headerIdx + "_header"} align="left">{row[header.field]}</TableCell>
                                        )
                                    })
                                }
                                {
                                    actions.length > 0 ? <TableCell key={idx + "_cell"} align="right">{
                                        actions.map((action, actionIdx) => <IconBtn style={{ marginLeft: 5 }} key={actionIdx} onClick={() => action.action(row)}>{action.icon}</IconBtn>)
                                    }</TableCell> : <></>
                                }
                            </TableRow>
                            {
                                collapse && <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell key={idx + "_collapse_row"} style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={99}>
                                        <Collapse in={collapseIdx === idx} timeout="auto" unmountOnExit >
                                            <CollapseComponent style={{...collapseStyle}} {...props.collapseProps} data={row.collapseData}>{props.collapseChildren}</CollapseComponent>
                                        </Collapse>
                                    </TableCell>
                                </TableRow> 
                            }
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}